import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { User } from "src/app/session/models/user";
import { AccountService } from "../../../settings/services/account.service";
import { UserService } from "../../../session/services/user.service";
import { Account } from "src/app/settings/models/account";

interface MultiofficeData {
  firstName: string;
  lastName: string;
  email: string;
  accounts: Account[];
}

@Component({
  selector: "im-multioffice-dialog",
  templateUrl: "./multioffice-dialog.component.html",
  styleUrls: ["./multioffice-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MultiofficeDialogComponent implements OnInit {
  public dataToDisplay: MultiofficeData = {
    firstName: "",
    lastName: "",
    email: "",
    accounts: [],
  };

  public isLoading: boolean = true;
  public canConfirm: boolean = false;

  private accounts: Account[] = [];
  private principalAccount: Account;
  private selectedAccountId: string = "";
  private user: User;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private userService: UserService,
    private accountService: AccountService,
  ) {}

  public async ngOnInit(): Promise<void> {
    Promise.all([this.getUser(), this.getAccounts()])
      .then((_) => {
        this.prepareDataToDisplay();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private async getUser(): Promise<void> {
    try {
      this.user = await this.userService.getCurrentUser();
      this.user.selectedAcc = this.user.accountId;
    } catch (err) {
      console.error("get user", err);
      throw err;
    }
  }

  private async getAccounts(): Promise<void> {
    try {
      this.accounts = await this.accountService.getAccounts();
    } catch (err) {
      console.error("get accounts", err);
      throw err;
    }
  }

  private prepareDataToDisplay(): void {
    this.dataToDisplay.firstName = this.user.firstName;
    this.dataToDisplay.lastName = this.user.lastName;
    this.dataToDisplay.email = this.user.email;

    this.principalAccount = this.accounts.find(
      (account) => account.id == this.user.accountId,
    );
    var accountsToAdd = this.accounts.filter(
      (account) =>
        this.user.secondaryAccountIds.includes(account.id) ||
        account.id == this.user.accountId,
    );
    accountsToAdd.forEach(
      (account) => (account["selected"] = account.id == this.user?.selectedAcc),
    );

    this.dataToDisplay.accounts = [...accountsToAdd];
    this.dataToDisplay.accounts.sort(this.sortAlgorithm);
  }

  public onAccountSelectedChange(optionId: string): void {
    this.dataToDisplay.accounts.forEach(
      (account) => (account["selected"] = account.id == optionId),
    );
    this.selectedAccountId = optionId;
    this.canConfirm = optionId != this.principalAccount.id;
  }

  public onApplyButton(): void {
    var accountToSend = this.accounts.find(
      (account) => account.id == this.selectedAccountId,
    );
    this.dialogRef.close({ accountId: accountToSend.id });
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

  public onAccountRowClick(id: string): void {
    this.onAccountSelectedChange(id);
  }

  private sortAlgorithm(a: Account, b: Account) {
    if (a["selected"]) return -1;
    else if (b["selected"]) return 1;
    else {
      if (a.name < b.name) return -1;
      else return 1;
    }
  }
}
